<app-checkout-second-step-page
  [addresses]="addresses$ | async"
  [order]="cartOrder$ | async"
  [committing]="committing$ | async"
  [errors]="commitError$ | async"
  [checkoutPageSettings]="checkoutPageSettings$ | async"
  (detailsChanged)="detailsChanged($event)"
  (createOrder)="createOrder($event)"
></app-checkout-second-step-page>
